import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListTipoPublicaciones from './ListTipoPublicaciones';
import TipoPublicacionesEdit from './TipoPublicacionesEdit';
import TipoPublicacionesNew from './TipoPublicacionesNew';
import BusquedaGrupoPlanes from './BusquedaGrupoPlanes';

export default class AdmTipoPublicaciones extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListTipoPublicaciones/>}/>
                    <Route path="Editar/:id" element={<TipoPublicacionesEdit/>}/>
                    <Route path="Nuevo" element={<TipoPublicacionesNew/>}/>
                    <Route path="GrupoPlanes/Busqueda" element={<BusquedaGrupoPlanes/>}/>
                </Routes>
            </div>
        );
    }
}